import { SagaIterator } from 'redux-saga';
import { all, call } from 'redux-saga/effects';
import watchMasterData from './entities/masterData/saga';
import watchProviderData from './entities/provider/saga';
import watchExperianData from './entities/experianQuestion/saga';
import watchAgreeTermsData from './entities/agreeTerms/saga';
import watchPaymentData from './entities/payment/saga';
import watchAttachmentData from './entities/attachment/saga';
import watchClinicData from './entities/clinic/saga';

export default function* rootSaga(): SagaIterator {
    yield all([
        call(watchMasterData),
        call(watchProviderData),
        call(watchExperianData),
        call(watchAgreeTermsData),
        call(watchPaymentData),
        call(watchAttachmentData),
        call(watchClinicData)
    ]);
}


// WEBPACK FOOTER //
// ./src/modules/rootSaga.ts